'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = undefined;

var _colorUtils = require('./color-utils');

Object.keys(_colorUtils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _colorUtils[key];
    }
  });
});

var _tokens = require('./tokens');

Object.keys(_tokens).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tokens[key];
    }
  });
});

var _colorsModule = require('./tokens/colors.module.js');

var colors = _interopRequireWildcard(_colorsModule);

var _typographyModule = require('./tokens/typography.module.js');

var typography = _interopRequireWildcard(_typographyModule);

var _layoutModule = require('./tokens/layout.module.js');

var layout = _interopRequireWildcard(_layoutModule);

var _containersModule = require('./tokens/containers.module.js');

var containers = _interopRequireWildcard(_containersModule);

var _animationModule = require('./tokens/animation.module.js');

var animation = _interopRequireWildcard(_animationModule);

var _bannersModule = require('./tokens/banners.module.js');

var banners = _interopRequireWildcard(_bannersModule);

var _popupsModule = require('./tokens/popups.module.js');

var popups = _interopRequireWildcard(_popupsModule);

var _tablesModule = require('./tokens/tables.module.js');

var tables = _interopRequireWildcard(_tablesModule);

var _vizModule = require('./tokens/viz.module.js');

var viz = _interopRequireWildcard(_vizModule);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var tokens = exports.tokens = {
  colors: colors,
  typography: typography,
  layout: layout,
  containers: containers,
  animation: animation,
  banners: banners,
  tables: tables,
  viz: viz
};